<template>
  <div class="tw-mx-[-20px] tw-flex tw-flex-wrap">
    <div
      class="bg-blue-utilities tw-flex tw-w-full tw-items-center tw-justify-center tw-bg-uhblue-150 tw-bg-contain tw-bg-repeat tw-p-[20px]"
    >
      <div
        class="tw-mx-[24px] tw-my-[32px] tw-w-full lg:tw-my-[54px] xl:tw-max-w-screen-xl"
      >
        <div :class="[outerClasses]">
          <div v-if="landlordCity" class="contained text-center">
            <h4>
              View more properties in
              <a class="font-weight-600" :href="landlordCity.path">
                {{ landlordCity.name }}
              </a>
            </h4>
          </div>
          <form
            id="a_level_newsletter"
            name="a_level_newsletter"
            class="tw-rounded-[16px] tw-border tw-border-[#E5E7EB] tw-bg-white tw-p-[24px] lg:tw-p-[32px]"
            dusk="newsletter"
            @submit.prevent="submitSignUp"
          >
            <div class="tw-flex tw-flex-col tw-gap-[24px]">
              <div
                class="tw-flex tw-flex-col tw-gap-[16px] tw-text-primary-grey"
              >
                <h4
                  class="tw-m-0 tw-text-[20px] tw-font-extrabold tw-leading-[30px] lg:tw-text-[30px] lg:tw-leading-[45px]"
                >
                  <span v-if="signUpType === 'signUpCity'">
                    <template v-if="type === 'spare-rooms'">
                      More properties with spare rooms are set to go live
                    </template>
                    <template v-else>
                      More properties are set to go live
                    </template>
                    {{ city ? `in ${city.name}` : '' }} soon!
                  </span>
                  <span v-else-if="signUpType === 'signUpFilters'">
                    Nothing here...yet!
                  </span>
                  <span v-else-if="signUpType === 'signUpResults'">
                    Nothing standing out?
                  </span>
                </h4>
                <p
                  class="tw-text-[14px] tw-font-normal tw-leading-[21px] lg:tw-text-[16px] lg:tw-leading-[24px]"
                >
                  <span v-if="signUpType === 'signUpCity'">
                    <span v-if="type === 'spare-rooms'">
                      <span class="tw-block">
                        Sign up to our waitlist to get notified when the latest
                        properties matching your needs arrive.
                      </span>
                      <span class="tw-block">
                        Be the first to hear when new spare rooms go live!
                      </span>
                    </span>
                    <span v-else>
                      <span class="tw-block">
                        Sign up now and we'll send new property alerts straight
                        to your inbox.
                      </span>
                      <span class="tw-block">
                        Don't miss out on securing your perfect home!
                      </span>
                    </span>
                  </span>
                  <span v-else-if="signUpType === 'signUpFilters'">
                    <span class="tw-mb-[24px] tw-block">
                      We couldn't find any properties matching your specific
                      criteria.
                    </span>
                    <span class="tw-block">
                      Adjust your search, or sign up to our waitlist to get
                      notified when the latest properties matching your needs
                      arrive!
                    </span>
                  </span>
                  <span v-else-if="signUpType === 'signUpResults'">
                    <span class="tw-mb-[24px] tw-block">
                      Sign up to our waitlist to be the first to know when new
                      properties are listed matching your specific criteria.
                    </span>
                    <span class="tw-block">
                      Your perfect student home could be closer than you think.
                    </span>
                  </span>
                </p>
              </div>
              <div v-if="!success">
                <div
                  class="tw-flex tw-w-full tw-flex-col tw-items-stretch tw-justify-stretch tw-gap-[24px] lg:tw-flex-row"
                >
                  <div
                    class="tw-flex tw-grow-[2] tw-flex-col tw-text-primary-grey"
                  >
                    <label
                      class="tw-text-[16px] tw-font-normal tw-leading-[24px] after:tw-text-[#E02424] after:tw-content-['*']"
                    >
                      Full name
                    </label>
                    <input
                      id="FullName"
                      v-model="fullName"
                      class="tw-ease tw-min-h-[50px] tw-rounded-[8px] tw-border-[2px] tw-outline-none tw-transition-all tw-duration-300 focus:tw-border-[#1BA2DC] focus:tw-shadow-none"
                      :class="[
                        formErrors.fullName
                          ? 'tw-border-[#E02424]'
                          : 'tw-border-[#E5E7EB]',
                      ]"
                      style="box-shadow: none !important"
                      name="full_name"
                      type="text"
                      dusk="full-name"
                      required
                    />
                    <span
                      v-if="formErrors.fullName"
                      class="tw-mt-1 tw-text-[14px] tw-text-[#E02424]"
                      dusk="form-errors-full-name"
                    >
                      {{ formErrors.fullName }}
                    </span>
                  </div>
                  <div
                    class="tw-flex tw-grow-[2] tw-flex-col tw-text-primary-grey"
                  >
                    <label
                      class="tw-text-[16px] tw-font-normal tw-leading-[24px] after:tw-text-[#E02424] after:tw-content-['*']"
                    >
                      Email address
                    </label>
                    <input
                      id="email"
                      v-model="email"
                      class="tw-ease tw-min-h-[50px] tw-rounded-[8px] tw-border-[2px] tw-outline-none tw-transition-all tw-duration-300 focus:tw-border-[#1BA2DC] focus:tw-shadow-none"
                      :class="[
                        formErrors.email
                          ? 'tw-border-[#E02424]'
                          : 'tw-border-[#E5E7EB]',
                      ]"
                      style="box-shadow: none !important"
                      name="email"
                      type="text"
                      dusk="email"
                      required
                    />
                    <span
                      v-if="formErrors.email"
                      class="tw-mt-1 tw-text-[14px] tw-text-[#E02424]"
                      dusk="form-errors-email"
                    >
                      {{ formErrors.email }}
                    </span>
                  </div>
                  <div
                    class="tw-self-top tw-flex tw-w-full tw-max-w-full tw-grow-[2] tw-flex-col lg:tw-max-w-[300px] lg:tw-self-auto"
                  >
                    <button
                      class="tw-ease after:tw-ease tw-relative tw-w-full tw-rounded-full tw-bg-[#F49130] tw-px-0 tw-py-[13px] tw-text-center tw-text-[16px] tw-font-semibold tw-leading-[24px] tw-text-white tw-transition-all tw-duration-300 after:tw-absolute after:tw-left-1/2 after:tw-top-1/2 after:tw-h-0 after:tw-w-0 after:tw-rounded-full after:tw-bg-[#f38418] after:tw-transition-all after:tw-duration-300 after:tw-content-[''] hover:tw-text-white hover:after:tw-left-0 hover:after:tw-top-0 hover:after:tw-h-full hover:after:tw-w-full focus:after:tw-left-0 focus:after:tw-top-0 focus:after:tw-h-full focus:after:tw-w-full hover:disabled:after:tw-w-0 lg:tw-mb-auto lg:tw-mt-[24px]"
                      type="submit"
                      :disabled="!formCanBeSubmitted"
                      dusk="signup-submit"
                    >
                      <span class="tw-relative tw-z-10">Keep me updated</span>
                    </button>
                  </div>
                </div>
              </div>
              <div
                v-if="error"
                class="tw-mb-[16px] tw-rounded-[8px] tw-border-[2px] tw-border-[#E02424] tw-bg-[#FEF2F2] tw-p-3 tw-text-[#E02424]"
                v-html="error"
              ></div>
              <div
                v-if="success"
                class="tw-mb-[16px]"
                dusk="newsletter-thank-you"
              >
                <h3
                  class="tw-text-[18px] tw-font-bold tw-text-success-mid"
                  dusk="thank-you-message"
                >
                  Thank you for signing up!
                </h3>
              </div>
              <p
                v-else
                class="tw-text-[14px] tw-font-normal tw-leading-[21px] tw-text-primary-grey"
              >
                By entering your details you are confirming you're happy to
                receive marketing communications from UniHomes and its group
                companies
                <a
                  class="text-decoration-underline tw-text-[#00628F]"
                  href="/privacy-and-cookie-policies"
                  target="_blank"
                >
                  View our privacy policy </a
                >.
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'SignUpNew',
  props: {
    type: {
      default: null,
      type: String,
    },
    city: {
      default: null,
      type: [Object, String],
    },
    landlord: {
      default: null,
      type: [Object, String],
    },
    landlordCity: {
      default: null,
      type: [Object, String],
    },
    lettingSeasonEnd: {
      default: null,
      type: Number,
    },
    lettingSeasonNext: {
      default: null,
      type: Number,
    },
    outerClasses: {
      default: null,
      type: String,
    },
    propertiesCount: {
      default: null,
      type: Number,
    },
    route: {
      default: '/leads',
      type: String,
    },
    signUpType: {
      default: null,
      type: String,
    },
    universityCities: {
      default: null,
      type: Array,
    },
  },
  data: () => ({
    error: null,
    fullName: null,
    email: null,
    submitting: false,
    success: false,
    formErrors: {
      fullName: null,
      email: null,
      lastName: null,
    },
  }),
  computed: {
    formCanBeSubmitted() {
      return this.fullName && this.email && !this.submitting;
    },
    // Computed property to split the full name
    firstName() {
      // Split the full name by space and return the first part
      return this.fullName ? this.fullName.split(' ')[0] || '' : '';
    },
    lastName() {
      // Split the full name and return everything after the first part (concatenate if more than two names)
      if (!this.fullName) return '';
      const nameParts = this.fullName.split(' ');
      return nameParts.slice(1).join(' ') || ''; // Join the rest as the last name
    },
  },
  watch: {
    // Clear related errors when field values change
    fullName() {
      this.formErrors.fullName = null;
      this.formErrors.lastName = null;
    },
    email() {
      this.formErrors.email = null;
    },
  },
  methods: {
    validateForm() {
      let isValid = true;

      // Reset all errors
      this.formErrors = {
        fullName: null,
        email: null,
        lastName: null,
      };

      // Check if full name has at least two parts (first and last name)
      if (!this.fullName) {
        this.formErrors.fullName = 'Please enter your full name';
        isValid = false;
      } else if (!this.lastName) {
        this.formErrors.fullName = 'Please include your last name';
        isValid = false;
      }

      // Simple email validation
      if (!this.email) {
        this.formErrors.email = 'Please enter your email address';
        isValid = false;
      } else if (!this.isValidEmail(this.email)) {
        this.formErrors.email = 'Please enter a valid email address';
        isValid = false;
      }

      return isValid;
    },

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    async submitSignUp() {
      this.error = null;

      // Validate form before submitting
      if (!this.validateForm()) {
        return;
      }

      this.submitting = true;

      try {
        await axios.post(this.route, {
          city: this.city?.name
            ? this.city.name
            : this.landlord?.obfuscatedId
              ? 'Landlord'
              : 'Unknown',
          email: this.email,
          firstName: this.firstName,
          landlord: this.landlord?.obfuscatedId ?? null,
          lastName: this.lastName,
          url: window.location.href,
        });
        this.success = true;
      } catch (error) {
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors;
          if (errors) {
            if (errors.email && errors.email.length) {
              this.formErrors.email = errors.email[0];
            }

            if (errors.lastName && errors.lastName.length) {
              this.formErrors.lastName = errors.lastName[0];
              this.formErrors.fullName = 'Please include your last name';
            }
          } else if (error.response.data.message) {
            this.error = error.response.data.message;
          }
        } else if (error.response) {
          this.error =
            error.response.data.message ||
            'An error occurred during submission.';
        } else {
          this.error = 'Unable to submit your request. Please try again later.';
        }
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
<style scoped>
.select2-selection__rendered {
  line-height: 50px !important;
}
.select2-container .select2-selection--single {
  height: 50px !important;
}
.select2-selection__arrow {
  height: 50px !important;
}
</style>
